
import React from "react";
import { Bike as BikeIcon } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { BikeDetail } from "../types/bikeTypes";

interface BikeSpecificationsProps {
  bike: BikeDetail;
}

const BikeSpecifications: React.FC<BikeSpecificationsProps> = ({ bike }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Specifications</CardTitle>
        <CardDescription>Technical details about this bike</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="rounded-lg bg-muted p-4">
          <div className="flex justify-center">
            <BikeIcon className="h-24 w-24 text-bike-primary" />
          </div>
        </div>
        
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Model</span>
            <span className="font-medium">Standard e-Bike</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Serial Number</span>
            <span className="font-medium">{bike.serialNumber}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Added to Fleet</span>
            <span className="font-medium">
              {new Date(bike.createdAt).toLocaleDateString()}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Last Updated</span>
            <span className="font-medium">
              {new Date(bike.lastUpdated).toLocaleDateString()}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BikeSpecifications;
